import { InteractionTimeline } from "@/components/prooftree/InteractionTimeline"
import { SkillChip } from "@/components/prooftree/SkillChip"
import { Box } from "@/components/ui/box"
import { HStack } from "@/components/ui/hstack"
import { Text } from "@/components/ui/text"
import { VStack } from "@/components/ui/vstack"
import { Colors } from "@/constants/Colors"
import { ContactSkillTrend, getSkill, getSkillDomainColor } from "@/data/prooftree"
import { Minus, TrendingDown, TrendingUp } from "lucide-react-native"

export function SkillTrendCard({
  trend,
  compact = false,
}: {
  trend: ContactSkillTrend
  compact?: boolean
}) {
  const skill = getSkill(trend.skillId)
  const skillColor = getSkillDomainColor(trend.skillId)
  const trendColor =
    trend.direction === "positive"
      ? Colors.dark.growth
      : trend.direction === "negative"
        ? Colors.dark.error
        : Colors.dark.textSecondary
  const TrendIcon =
    trend.direction === "positive"
      ? TrendingUp
      : trend.direction === "negative"
        ? TrendingDown
        : Minus
  const signedChange = `${trend.changePercent > 0 ? "+" : ""}${trend.changePercent}%`

  return (
    <Box
      className="rounded-2xl border p-4"
      style={{
        backgroundColor: Colors.dark.surfaceSecondary,
        borderColor: `${trendColor}42`,
      }}
    >
      <VStack className="gap-3">
        <HStack className="items-start justify-between gap-3">
          <VStack className="flex-1 gap-2">
            <SkillChip skillId={trend.skillId} compact />
            <Text className="text-sm leading-5" style={{ color: Colors.dark.textSecondary }}>
              Current level {trend.currentLevel} · score {trend.currentScore}/100
            </Text>
          </VStack>
          <Box
            className="min-w-20 rounded-2xl px-3 py-2"
            style={{ backgroundColor: `${trendColor}1F` }}
          >
            <HStack className="items-center justify-center gap-1">
              <TrendIcon color={trendColor} size={15} />
              <Text className="text-sm font-bold" style={{ color: trendColor }}>
                {signedChange}
              </Text>
            </HStack>
          </Box>
        </HStack>

        <InteractionTimeline history={trend.history} color={skillColor} showLabels={!compact} />

        {compact ? null : (
          <Text className="text-sm leading-5" style={{ color: Colors.dark.textSecondary }}>
            {skill.title}: {trend.insight}
          </Text>
        )}
      </VStack>
    </Box>
  )
}
